import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import LeadForm from "./LeadForm"
import Loader from "components/Loader/Loader"
import { fetchData } from "utils/Common_api_functions"

const ViewLead = () => {
  document.title = "View Lead | Vintage Infra Equipment Sol PVT LTD"
  const { id } = useParams()

  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({})
  const [users, setUsers] = useState([])

  useEffect(() => {
    if (id) {
      fetchLeadData()
      fetchUsers()
    }
  }, [id])

  async function fetchLeadData() {
    const APIdata = await fetchData(setLoading, `leads/${id}`)
    if (APIdata?.success) {
      setFormData(APIdata?.data)
    }
  }

  async function fetchUsers() {
    const APIdata = await fetchData(setLoading, "users")
    if (APIdata?.success) {
      setUsers(APIdata?.data)
    }
  }

  return (
    <div className="page-content">
      <Breadcrumb title="Leads Management" breadcrumbItem="View Lead" />
      {loading && <Loader />}

      <LeadForm formData={formData} setFormData={setFormData} mode="view" users={users} />
    </div>
  )
}

export default ViewLead
